import React from 'react';
import {withRouter} from 'react-router-dom';
import ICBanner from 'common/components/banner/ICBanner';
import {Button, ExpandableSection} from '@amzn/awsui-components-react';
import ExecutionDashboard from '../../common/components/ExecutionDashboard';
import styles from './DetailPage.scss';

import {connect} from 'react-redux';
import * as actions from 'actions';
import PropTypes from 'prop-types';
import {TransformStepCardView} from "./components/TransformStepCardView";

import {v4 as uuidv4} from 'uuid';
import Spinner from "@amzn/awsui-components-react/polaris/spinner";


export class DetailPage extends React.Component {

  constructor(props) {
    super(props);
    const calcDetailsId = this.props.match.params.id;
    this.state = {
      calcDetailsId: calcDetailsId,
      calcDef: []
    }
    if (this.props.initialized && !this.props.detailsLoading) {
      const currentItem = this.props.jobsData.filter(item => item.id === this.state.calcDetailsId)[0];
      if (!this.props.columnsInitialized && !this.props.columnsLoading) {
        this.state.calcDef = this.assignGuid(currentItem.calculationDetails);
        this.props.fetchColumnMetadata();
      }
      if (!this.props.icDataInitialized[currentItem.agreementNumber] && !this.props.loading) {
        this.props.fetchICData({"agreementNumber": currentItem.agreementNumber});
      }
    }
    const items = this.props.jobsData.filter(item => item.id === this.state.calcDetailsId);
    if (items.length > 0) {
      const current = items[0];
      this.state.calcDef = this.assignGuid(current.calculationDetails);
    }
  }

  componentDidMount() {
    if (!this.props.initialized && !this.props.detailsLoading) {
      this.props.fetchJobsData();
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.initialized && !this.props.detailsLoading) {
      const currentItem = this.props.jobsData.filter(item => item.id === this.state.calcDetailsId)[0];
      if (!this.props.columnsInitialized && !this.props.columnsLoading) {
        this.setState({calcDef: this.assignGuid(currentItem.calculationDetails)});
        this.props.fetchColumnMetadata();
      }
      if (!this.props.icDataInitialized[currentItem.agreementNumber] && !this.props.loading) {
        this.props.fetchICData({"agreementNumber": currentItem.agreementNumber});
      }
    }
  }

  assignGuid(calcDef) {
    let newCalcDef = [];
    for (let x of calcDef) {
      const newObj = {...x};
      if (!x.hasOwnProperty("guid")) {
        newObj["guid"] = uuidv4();
      }
      newCalcDef.push(newObj);
    }
    return newCalcDef;
  }

  scrubGuid(calcDef) {
    let modifiedNewState = [...calcDef];
    // Remove the keyIndex assigned by the UI
    modifiedNewState = modifiedNewState.map(item => {
      const newItem = {...item};
      delete newItem.guid;
      return newItem;
    })
    return modifiedNewState;
  }

  static propTypes = {
    error: PropTypes.string,
    loading: PropTypes.bool,
    detailsLoading: PropTypes.bool,
    jobsData: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      integrationName: PropTypes.string,
      integrationType: PropTypes.string,
      description: PropTypes.string,
      calculation: PropTypes.string,
      fileName: PropTypes.string,
      sourceSystem: PropTypes.string,
      targetSystem: PropTypes.string,
      dataType: PropTypes.string,
      agreementNumber: PropTypes.string,
      calculationDetails: PropTypes.array,
    })),

    fetchICData: PropTypes.func,
    downloadSource: PropTypes.func,
  };

  static defaultProps = {
    loading: false,
    detailsLoading: true,
    error: null,
    iCData: {},
    jobsData: [],
    fetchICData: () => {
    },
    downloadSource: () => {
    },
    fetchColumnMetadata: () => {

    }
  }

  render() {
    if (this.props.detailsLoading || !this.props.initialized) {
      return <div>Loading ...</div>
    }
    const currentItem = this.props.jobsData.filter(item => item.id === this.state.calcDetailsId)[0]

    const cardViewChange = (newState) => {
      this.setState({calcDef: newState});
    };
    const spinner = this.props.saving? <Spinner/>: "";
    return (
      <div className={styles.wrapper}>
        <ICBanner
          bannerText="Intercompany Data Integration and Transformation Tool for Intercompany Applications"></ICBanner>
        <br/>
        <div>Home > {currentItem.integration_type} > {currentItem.calculation}</div>
        <br/>
        <div className="awsui-util-container">
          <div className="awsui-util-container-header">
            <h2 className="awsui-util-font-size-3">Calculation Description</h2>
          </div>
          <div>{currentItem.description}</div>
        </div>
        <ExpandableSection header="Calculation Details" variant="container">
          <TransformStepCardView data={this.state.calcDef} onChange={cardViewChange} />
          <Button variant="primary" onClick={() => {
            this.props.saveCalcDetailsData(this.state.calcDetailsId, this.scrubGuid(this.state.calcDef));
          }} disabled={this.props.detailsLoading || this.props.columnsLoading || this.props.saving}>
            Save
          </Button>
          {spinner}
        </ExpandableSection>
        <br/>
        <ExecutionDashboard
          id={currentItem.agreementNumber}
          handleSourceData={this.handleSourceData}
          handleTransformedData={this.handleTransformedData}
        />

      </div>
    );
  }

}

export const mapStateToProps = (state) => {
  const {fetchICData} = state;
  const {
    loading,
    error,
  } = fetchICData;
  const icDataInitialized = fetchICData.initialized;

  const {fetchColumnMetadata} = state;
  const {columnMetadata} = fetchColumnMetadata;
  const columnsLoading = fetchColumnMetadata.loading;
  const columnsInitialized = fetchColumnMetadata.initialized;

  const {fetchJobsData} = state;
  const {jobsData} = fetchJobsData;
  const detailsLoading = fetchJobsData.loading;
  const {initialized} = fetchJobsData

  const {saveCalcDetailsData} = state;
  const {saving} = saveCalcDetailsData;

  return {
    loading: loading,
    detailsLoading: detailsLoading,
    jobsData: jobsData,
    columnMetadata: columnMetadata,
    error: error,
    initialized: initialized,
    columnsLoading: columnsLoading,
    columnsInitialized: columnsInitialized,
    icDataInitialized: icDataInitialized,
    saving: saving
  };
};

const mapDispatchToProps = {
  fetchICData: actions.fetchICData,
  fetchJobsData: actions.fetchJobsData,
  saveCalcDetailsData: actions.saveCalcDetailsData,
  fetchColumnMetadata: actions.fetchColumnMetadata
};

const DetailPageContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DetailPage);

export default withRouter(DetailPageContainer);